import React from "react";

import Modal from "../Modal";
import * as styles from "./BulkUpdate.module.scss";
import FieldUpdate from "./FieldUpdate";

// TODO -- maybe define this in the Rails database or codebase
const fieldSchema = [
  {
    name: "title",
    label: "Title",
    fieldType: "simple",
    defaultPolicy: "replace",
  },
  {
    name: "year",
    label: "Year",
    fieldType: "simple",
    defaultPolicy: "replace",
  },
  {
    name: "medium",
    label: "Media",
    fieldType: "multiline",
    defaultPolicy: "replace",
  },
  {
    name: "dimensions",
    label: "Dimensions",
    fieldType: "multiline",
    defaultPolicy: "replace",
  },
  {
    name: "pricing_notes",
    label: "Pricing notes",
    fieldType: "multiline",
  },
  {
    name: "edition",
    label: "Edition",
    fieldType: "multiline",
    defaultPolicy: "replace",
  },
  {
    name: "artist_override",
    label: "Artist override",
    fieldType: "multiline",
    defaultPolicy: "replace",
  },
  {
    name: "status",
    label: "Status",
    fieldType: "status",
    defaultPolicy: "replace",
  },
  {
    name: "location",
    label: "Location",
    fieldType: "multiline",
    defaultPolicy: "replace",
  },
  {
    name: "inventory",
    label: "Inventory #",
    fieldType: "multiline",
    defaultPolicy: "replace",
  },
  {
    name: "description",
    label: "Description",
    fieldType: "multiline",
    defaultPolicy: "below",
  },
  {
    name: "links",
    label: "Links",
    fieldType: "multiline",
    defaultPolicy: "below",
  },
  {
    name: "provenance",
    label: "Provenance",
    fieldType: "multiline",
    defaultPolicy: "below",
  },
  {
    name: "condition",
    label: "Condition report",
    fieldType: "multiline",
    defaultPolicy: "below",
  },
  {
    name: "cost",
    label: "Cost description",
    fieldType: "multiline",
    defaultPolicy: "below",
  },
  {
    name: "notes",
    label: "Notes",
    fieldType: "multiline",
    defaultPolicy: "below",
  },
];

const defaultState = {
  open: false,
  items: [],
  selectedField: "",
};

export default class BulkUpdate extends React.Component {
  state = defaultState;

  componentDidMount() {
    window.addEventListener("openBulkUpdateReactComponent", this.handleOpen);
  }

  componentDidUpdate(prevProps, prevState) {
    // get information about the selected items
    const { items } = this.state;
    const newItems = [];

    document
      .querySelectorAll(".bulk-actions-checkbox:checked")
      .forEach((element) => {
        const { id, classname } = element.dataset;
        if (classname === "Work") newItems.push({ id, classname });
      });

    if (JSON.stringify(items) !== JSON.stringify(newItems)) {
      this.setState({ items: newItems });
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.setState(defaultState);
  };

  handleClickField = (e) => {
    const { fieldName } = e.target.dataset;
    this.setState({ selectedField: fieldName });
  };

  handleClickBack = (e) => {
    this.setState({ selectedField: "" });
  };

  render() {
    const { open, items, selectedField } = this.state;

    if (selectedField) {
      const fieldInfo = fieldSchema.filter(
        (field) => field.name === selectedField
      )[0];

      return (
        <Modal isOpen={open} onClose={this.handleClose}>
          <FieldUpdate
            items={items}
            fieldInfo={fieldInfo}
            onClickBack={this.handleClickBack}
          />
        </Modal>
      );
    }

    if (!items.length) {
      return (
        <Modal isOpen={open} onClose={this.handleClose}>
          <h1 className={styles.h1}>Bulk update works</h1>
          <p>
            You haven't selected any work records. Please click the checkboxes
            next to the work records that you would like to update.
          </p>
        </Modal>
      );
    }

    return (
      <Modal isOpen={open} onClose={this.handleClose}>
        <h1 className={styles.h1}>Bulk update works</h1>
        <p>
          You have selected {items.length} work record
          {items.length === 1 ? "" : "s"} which will be affected by one of the
          following actions:
        </p>
        <ul className={styles.fieldOptionList}>
          {fieldSchema.map((field) => (
            <li key={field.name} className={styles.fieldOption}>
              <button
                onClick={this.handleClickField}
                data-field-name={field.name}
              >
                {field.label}
              </button>
            </li>
          ))}
        </ul>
      </Modal>
    );
  }
}
